import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class SalesHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getMachineSales(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			let path = '/dashboard/get_machine_sales';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getSaleByMachine(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_dyndb_sales_by_mid';
			const params = {
				body: queryParams
			};
			API.post(this.apiName, path, params).then(macSales => {
				this.getSaleCntByMachine(queryParams)
				.then(countDet => {
					const saleByMac = {
						data: macSales.res_data,
						LEK: macSales.LastEvaluatedKey,
						count: countDet.Count
					};
					observer.next(saleByMac);
				})
				.catch(error => {
					observer.error(error);
				});
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getSaleCntByMachine(queryParams: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const path = '/dashboard/get_dyndb_sales_cnt_by_mid';
			const params = {
				body: queryParams
			};
			API.post(this.apiName, path, params).then(macSalesCnt => {
				resolve(macSalesCnt);
			}).catch(err => {
				console.log(err.response);
				reject(err);
			});
		});
	}

	getSaleByMember(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_dyndb_sales_by_member';
			const params = {
				body: queryParams
			};
			API.post(this.apiName, path, params).then(macSales => {
				this.getSaleCntByMember(queryParams)
				.then(countDet => {
					const saleByMac = {
						data: macSales.res_data,
						LEK: macSales.LastEvaluatedKey,
						count: countDet.Count
					};
					observer.next(saleByMac);
				})
				.catch(error => {
					observer.error(error);
				});
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getSaleCntByMember(queryParams: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const path = '/dashboard/get_dyndb_sales_cnt_by_member';
			const params = {
				body: queryParams
			};
			API.post(this.apiName, path, params).then(macSalesCnt => {
				resolve(macSalesCnt);
			}).catch(err => {
				console.log(err.response);
				reject(err);
			});
		});
	}

	getVendStatusCodes(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_vend_status_dict';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(vend_codes => {
				const result = {};
				for (const code of vend_codes) {
					result[code.vend_code] = code.code_details;
				}
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getActivityCodes(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_user_act_dict';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(ua_codes => {
				const result = {};
				for (const code of ua_codes) {
					result[code.sm_code] = code.sm_code_details;
				}
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getActivityLogs(trn_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_user_act/' + trn_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(ua_logs => {
				observer.next(ua_logs);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
